import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Component } from "react";

class SignUpSuccess extends Component {
  state = {};
  render() {
    return (
      <div className="">
        <div className="mainform">
          <p className="forgotPasswordMessage">
            {" "}
            <p
              style={{
                color: "green",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <FontAwesomeIcon size="2x" icon={faCheckCircle} />
            </p>
            Thank you for signing up{" "}
          </p>
          <p style={{ textAlign: "center" }}>
            {/* Your login credential has been sent to your email. */}
            Verification link has been sent to your email address.
          </p>
          <p style={{ textAlign: "center" }}>
            Please verify your email address to get started.
          </p>
          {/* <p style={{ textAlign: "center" }}>
            <a href="/login" style={{ color: "blue" }}>
              Click here
            </a>{" "}
            to login.
          </p> */}
        </div>
      </div>
    );
  }
}

export default SignUpSuccess;



// WEBPACK FOOTER //
// ./src/components/public/SignUpSuccess.js